/**
 * SND-17557 — "move to wishlist" heart in the cart (drawer + /cart page).
 *
 * Wishlist King (Appmate) exposes a headless global `window.WishlistKing`
 * (see assets/snd-card-actions.js): .addWishlistItem({ productHandle, variantId }).
 * Flow: add to wishlist -> remove the cart line through the theme's own
 * cart-items-component (onLineItemRemove), so the row animates out exactly
 * like the bin does and the drawer/badge stay in sync.
 *
 * Buttons render `hidden` and are revealed only once the app is confirmed
 * loaded; if the app is missing, nothing appears. Click handling is delegated
 * on document because the cart re-renders (section morph) after every update.
 */
(() => {
  const SEL = '[data-snd-cart-wish]';
  let ready = false;

  const reveal = () => document.querySelectorAll(SEL).forEach((b) => b.removeAttribute('hidden'));

  const waitFor = (test, timeout = 12000, every = 200) =>
    new Promise((resolve) => {
      const t0 = Date.now();
      const tick = () => {
        const v = test();
        if (v) return resolve(v);
        if (Date.now() - t0 > timeout) return resolve(null);
        setTimeout(tick, every);
      };
      tick();
    });

  waitFor(() => {
    const wk = window.WishlistKing;
    return wk && typeof wk.addWishlistItem === 'function' ? wk : null;
  }).then((wk) => {
    if (!wk) return;
    ready = true;
    reveal();
    // cart re-renders bring fresh (hidden) buttons
    const mo = new MutationObserver(() => reveal());
    mo.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('click', async (event) => {
    const btn = event.target instanceof Element ? event.target.closest(SEL) : null;
    if (!btn || !ready) return;
    event.preventDefault();
    if (btn.classList.contains('is-busy')) return;
    const wk = window.WishlistKing;
    const handle = btn.dataset.productHandle;
    if (!wk || !handle) return;

    btn.classList.add('is-busy');
    try {
      const payload = { productHandle: handle };
      const variantId = parseInt(btn.dataset.variantId, 10);
      if (variantId) payload.variantId = variantId;
      await wk.addWishlistItem(payload);
      btn.classList.add('is-done');

      const line = parseInt(btn.dataset.line, 10);
      const items = btn.closest('cart-items-component');
      if (items && typeof items.onLineItemRemove === 'function' && line) {
        items.onLineItemRemove(line);
      } else {
        const bin = btn.parentElement && btn.parentElement.querySelector('.cart-items__remove:not(.snd-cart-wish)');
        if (bin) bin.click();
      }
    } catch (error) {
      console.warn('[snd-cart-wishlist]', error);
      btn.classList.remove('is-busy');
    }
  });
})();
